import { Location } from "react-router-dom";

export const isNotTokenDependent = (location: Location) => {
    return !location.pathname.includes("emailConfirmation") &&
        !location.pathname.includes("provideEmail") &&
        !location.pathname.includes("registration") &&
        !location.pathname.includes("changeForgottenPassword");
}